/* @file 定制客运 线路排班 */
<template>
  <div id="customize">
    <custom-table v-if="tableShow" ref="customTable" :has-organization="true" :customOptions="customOptions"
      :columns="columns" addText="创建线路" @addFn="addClick" addTexts="配置分类标签" @addFns="settinLabel" query-mode="true"
      autoHeight="600">
      <template slot="search-button-left">
        <div class="condition" style="justify-content: flex-start;">
          <el-radio-group v-model="customOptions.params.schedulingType" @change="queryFn">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button v-for="(val, i) in $const.SCHELINGTYPESEARCH" :key="i" :label="val.value">
              {{ val.label }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <template slot="search-button-right" v-if="btnPreFn('survey_line', false)">
        <el-button type="primary" @click="showSupervise = true">客运监管</el-button>
      </template>

      <template slot="table-operation">
        <el-table-column label="操作" width="120px" v-slot="{ row }" fixed="right">

          <el-button type="text" @click="operationClick(row)">排班</el-button>

          <el-dropdown @command="handleCommand($event, row)">
            <span class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="detailClick">线路详情</el-dropdown-item>

              <el-dropdown-item command="ticketRestrictionsConfig" v-if="btnPreFn('ticket_restrictions', false)">购票限制
              </el-dropdown-item>
              <el-dropdown-item v-if="btnPreFn('line_driver_register', false)" command="routeReporting">线路报班
              </el-dropdown-item>
              <el-dropdown-item command="removeClick">删除线路</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </el-table-column>
      </template>


      <template v-slot:table-header="item">
        <template v-if="item.prop == 'commissionConfigName'">
          专线订单提成
          <el-tooltip class="item" effect="dark" content="仅适用于专线订单提成，专线包车提成请在专线包车配置页面中设置" placement="top">
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <template v-else>{{ item.label }}</template>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'commissionConfigName'">


          <span class="link" @click="row.commissionConfigName ? lookCommissionConfig(row) : null" :style="{
            color: row.commissionConfigName ? ' #0099FF' : '#999',
            'text-decoration': row.commissionConfigName
              ? 'underline'
              : 'none',
          }">
            {{ row.commissionConfigName || "无提成规则" }}</span>
        </template>
        <template v-else-if="item.prop === 'lineType'">
          {{ row.lineType | filterLineType }}
        </template>
        <template v-else-if="item.prop === 'labelName'">
          <i @click="saveLabelShowFn(row)" v-if="btnPreFn('scheduling_edit', false)" class="el-icon-edit " style="color: #1A93FF;font-size: 18px;cursor: pointer"></i> {{ row.labelName }}
        </template>



        <span v-else-if="item.prop === 'schedulingDate'">
          <span v-if="row.schedulingDate">{{ row.schedulingDate }}</span>
          <span v-if="!row.schedulingDate" style="color: #999">未排班</span>
        </span>

        <template v-else-if="item.prop === 'dutyVehicle'">
          <el-tooltip>
            <p slot="content">{{ row.dutyVehicle }}</p>
            <p v-if="row.dutyVehicle"
              style="max-height: 46px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;white-space: normal;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
              {{ row.dutyVehicle }}
            </p>
          </el-tooltip>
          <span v-if="!row.dutyVehicle" style="color: #999">无车辆</span>
        </template>

        <template v-else-if="item.prop === 'ticketRestrictions'">
          <span class="tips">{{ row.ticketRestrictions == 1 ? '非实名' : '实名' }}</span>
        </template>
        <span v-else-if="item.prop === 'driverRegister'">
          <span class="tips">{{ row.driverRegister == 1 ? row.driverRegisterNum : '未开放报班' }}</span>
        </span>

        <span v-else-if="item.prop === 'startStationName'">
          <div style="display: flex; align-items: center">
            <el-tag v-if="row.schedulingType" effect="plain" :type="row.schedulingType == 1
              ? ''
              : row.schedulingType == 2
                ? 'info'
                : 'success'
              " style="margin-right: 8px">
              {{
                new Map([
                  [1, "标准模式"],
                  [2, "自由派单"],
                  [3, "选座模式"],
                ]).get(row.schedulingType)
              }}
            </el-tag>
            <div>
              <div style="font-weight: 600">{{ row.startStationName }}</div>
              <div style="color: #999">{{ row.startProvincialCity }}</div>
            </div>
          </div>
        </span>

        <span v-else-if="item.prop === 'fee'">

          <div class="util-money">
            {{ row.fee ? ("¥" + row.fee + ((row.schedulingType == 3 || row.isSameRailFee == 2) ? '起' : '')) : "-" }}
          </div>


        </span>
        <span v-else-if="item.prop === 'endStationName'">
          <div style="font-weight: 600">{{ row.endStationName }}</div>
          <div style="color: #999">{{ row.endProvincialCity }}</div>
        </span>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <el-dialog width="30%" title="更换提成规则" :visible.sync="innerVisible" append-to-body>
      <el-table border stripe max-height="600" size="mini" class="zoeTable" empty-text="暂无数据" highlight-current-row
        :data="commissionConfigList">
        <el-table-column :show-overflow-tooltip="true" prop="name" label="规则名称">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="type" label="提成规则" v-slot="scope">
          {{ scope.row.type == 1 ? "比例提成" : "阶梯提成" }}
        </el-table-column>
        <el-table-column label="操作" width="80" v-slot="scope">
          <el-radio :label="scope.$index" v-model="radioCommissionConfig" :disabled="disableCommissionConfig"
            @change.native="getCurrentRow(scope.row)"><span></span></el-radio>
        </el-table-column>
      </el-table>
      <el-switch style="margin: 10px 0" v-model="disableCommissionConfig" active-text="无提成规则"
        @change="changeCommissionConfig">
      </el-switch>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCommissionConfig">保存
        </el-button>
        <el-button @click="innerVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看提成规则" :visible.sync="outerVisible">
      <div class="blueInfo" style="margin: 10px 0 20px 0; width: auto">
        <p>
          * 假设提成比例为10%，则司机每笔班次的收入提成10%
          <br />
          * 以订单金额进行核算，例如：订单金额￥100，优惠券折扣￥10，实付金额￥90，将按￥100核算提成
        </p>
      </div>
      <div class="box">
        <div class="item">
          <span class="title">提成方式：</span>
          <span class="value">{{
            commissionConfigView.type == 1 ? "比例提成" : "阶梯提成"
          }}</span>
        </div>
        <div class="item">
          <span class="title">规则名称：</span>
          <span class="value">{{ commissionConfigView.name }}</span>
        </div>
        <div class="item">
          <span class="title">机构名称：</span>
          <span class="value">{{ commissionConfigView.organizationName }}</span>
        </div>

        <template v-if="commissionConfigView.type === 1">
          <div class="item">
            <span class="title">正常下单：</span>
            <span class="value">{{ commissionConfigView.wechatOrderProportion }}%</span>
          </div>
          <div class="item">
            <span class="title">扫码下单：</span>
            <span class="value">{{ commissionConfigView.fastOrderProportion }}%</span>
          </div>
          <div class="item">
            <span class="title">司机下单：</span>
            <span class="value">{{ commissionConfigView.driverOrderProportion }}%</span>
          </div>
          <div class="item">
            <span class="title">后台下单：</span>
            <span class="value">{{ commissionConfigView.systemOrderProportion }}%</span>
          </div>
        </template>

        <template v-else>
          <div class="item" v-for="(item, index) in commissionConfigView.commissionConfigRules" :key="index">
            当实付金额为
            <strong style="margin: 0 10px">{{ item.minFee }}元</strong>
            至
            <strong style="margin: 0 10px">{{ item.maxFee }}元 </strong>
            提成方式为
            <strong style="margin: 0 10px">{{
              item.ruleType === 1 ? "比例提成" : "定额提成"
            }}</strong>
            司机提成
            <strong style="margin: 0 10px">{{ item.ruleNum }}
              {{ item.ruleType == 1 ? "％" : "元" }}
            </strong>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCommissionConfigList()">更换
        </el-button>
        <el-button @click="outerVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="配置分类标签" :visible.sync="labelVisble" width="25%" @close="labelVisble = false">
      <div style="margin-bottom: 10px;color: #999;">您可以创建自定义标签，用于线路分类</div>
      <el-table max-height="500px" border empty-text="暂无数据" :data="labelList">
        <el-table-column label="标签名称" prop="name">
          <template v-slot="scope">
            <div v-if="scope.row.edit">
              <el-input v-model="scope.row.name" placeholder="请输入标签名称" maxlength="8"></el-input>
            </div>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template v-slot="scope">
            <el-button v-if="scope.row.edit" @click="addLabel(scope.row)" type="text" size="small">保存</el-button>
            <el-button v-if="!scope.row.edit" type="text" size="small" @click="deleteLabel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-show="!(labelList.slice(-1)[0] && labelList.slice(-1)[0].edit)"
        style="border: 1px #dcdfe6 dashed;margin-top: 20px;padding: 10px;width: 100%;" @click="addLabelClick">添加标签
      </el-button>
    </el-dialog>

    <el-dialog title="设置分类标签" :visible.sync="labelSetVisble" width="25%"
      @close="labelSetVisble = false; labelId = null;">
      <div style="margin-bottom: 10px; color: #999">您可以创建自定义标签，用于线路分类</div>
      <el-table max-height="500px" border empty-text="暂无数据" :data="labelList">
        <el-table-column label="标签名称" prop="name">
          <template v-slot="scope">
            <div v-if="scope.row.edit">
              <el-input v-model="scope.row.name" placeholder="请输入标签名称"></el-input>
            </div>
            <div v-else>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="选择" width="80" align="center">
          <template v-slot="scope">
<!--    隐藏labelID        -->
            <el-radio v-model="labelId" :label="scope.row.id">&nbsp;</el-radio>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="border: 1px #dcdfe6 solid;margin-top: 20px;padding: 10px;width: 100%;" @click="saveSetLabel">
        确认
      </el-button>
    </el-dialog>

    <!--购票限制弹框-->
    <ticket-restrictions-dialog
      :visible.sync="ticketRestrictionsConfigVisible"
      :row-data="ticketRestrictionsConfigRow"
      @success="saveTicketRestrictions"
    />

    <el-drawer :visible.sync="showSupervise" title="" size="900px">
      <supervise v-if="showSupervise" @close="superviseClose"></supervise>
    </el-drawer>

  </div>
</template>

<script>
import VueQr from "vue-qr";
import lineSupervise from './components/lineSupervise'
import TicketRestrictionsDialog from './components/TicketRestrictionsDialog'
import supervise from './components/Supervise'

export default {
  name: "customize",
  components: { VueQr, lineSupervise, TicketRestrictionsDialog,supervise },
  data() {
    return {
      tableShow: false,
      outerVisible: false,
      innerVisible: false,
      line: null,
      commissionConfigView: {},
      commissionConfigList: [],
      disableCommissionConfig: false,
      radioCommissionConfig: null,
      checkCommissionConfig: null,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/line/scheduling",
        // 请求的参数列表
        params: {
          schedulingType: "",
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "labelId",
            name: "分类标签",
            value: "",
            option: [],
            disabled: false,
          },
          {
            type: "select",
            field: "ticketRestrictions",
            name: "购票限制",
            value: "",
            option: [
              { label: '实名', value: "2" },
              { label: '非实名', value: "1" },
            ],
            disabled: false,
          },
          {
            type: "input",
            field: "startStationName",
            name: "出发地",
            value: "",
          },
          {
            type: "input",
            field: "endStationName",
            name: "目的地",
            value: "",
          }
        ],
      },
      columns: [
        { prop: "labelName", label: "分类标签", width: 150 },
        { prop: "startStationName", label: "出发地", width: 300 },
        { prop: "endStationName", label: "目的地", width: 300 },
        { prop: "schedulingDate", label: "已排班次", width: 150 },
        { prop: "dutyVehicle", label: "值班车辆", width: 200 },
        { prop: "fee", label: "线路票价" },
        { prop: "commissionConfigName", label: "专线订单提成", minWidth: 120 },
        { prop: "ticketRestrictions", label: "购票限制" },
        { prop: "driverRegister", label: "报班司机数", minWidth: 100 },
      ],
      labelVisble: false,
      labelList: [],
      labelId: null,
      labelSetVisble: false,
      checkRow: null,

      qrsize: 128,
      qrsizeOpt: [
        {
          value: 128,
          label: "128*128",
        },
        {
          value: 256,
          label: "256*256",
        },
        {
          value: 512,
          label: "512*512",
        },
        {
          value: 1024,
          label: "1024*1024",
        },
      ],
      qrtext: null,
      qrcodeInfo: {
        startStationName: null,
        endStationName: null,
      },

      ticketRestrictionsConfigVisible: false,
      ticketRestrictionsConfigRow: {},
      showSupervise: false
    };
  },
  watch: {
    innerVisible(val) {
      if (!val) {
        this.radioCommissionConfig = null;
        this.checkCommissionConfig = null;
        this.disableCommissionConfig = false;
      }
    },
  },
  created() {
    this.getlabelList();
  },
  methods: {
    superviseClose() {
      this.showSupervise = false
    },
    saveTicketRestrictions() {
      this.ticketRestrictionsConfigVisible = false;
      this.$refs.customTable.listFn();
    },
    detailClick(row) {
      this.$router.push({ path: '/customizeDetail', query: { id: row.id } })
    },
    queryFn() {
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
    },
    // 点击下拉按钮
    handleCommand(e, row) {
      this[e](row);
    },

    /* 分类标签列表 */
    async getlabelList() {
      let url = "/api/v1/manage/lineLabel/labelList";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.labelList = [];
          this.customOptions.search[0].option = [
            {
              value: null,
              label: "未配置标签",
            },
          ];
          this.customOptions.search[0].disabled = true;
        } else {
          this.labelList = data.data;
          this.customOptions.search[0].option = Array.from(
            data.data,
            (val) => ({ label: val.name, value: val.id })
          );
          this.customOptions.search[0].disabled = false;
        }
        this.tableShow = true;
        this.$forceUpdate();
      }
    },

    addLabelClick() {
      if (this.labelList.length == 30) {
        this.$message.info("最多添加30个标签");
        return;
      }
      this.labelList.push({ name: null, edit: true });
    },
    /* 添加标签 */
    async addLabel(item) {
      if (!item.name) {
        this.$message.warning("请输入标签名称");
        return;
      }
      let url = "/api/v1/manage/lineLabel/save";
      let data = await this.$axios.post(url, item);
      if (data && data.code === 1) {
        this.$message.info("已添加");
        this.getlabelList();
      }
    },

    /* 删除标签 */
    async deleteLabel(item) {
      let url = "/api/v1/manage/lineLabel";
      let data = await this.$axios.delete(url, { id: item.id });
      if (data && data.code === 1) {
        this.$message.info("已删除");
        this.getlabelList();
        this.$refs.customTable.listFn();
      }
    },

    /* 配置分类标签 */
    settinLabel() {
      this.getlabelList();
      this.labelVisble = true;
    },
    saveLabelShowFn(row){
      this.checkRow = {...row} ;
      this.labelSetVisble = true;
    },
    async saveSetLabel() {
      let url = "/api/v1/manage/lineLabel/setClassifyLabel";
      let labelName = this.labelList.find((val) => val.id == this.labelId).name;
      let data = await this.$axios.post(url, {
        lineId: this.checkRow.id,
        labelId: this.labelId,
        labelName,
      });
      if (data && data.code === 1) {
        this.$message.info("已设置标签");
        this.$refs.customTable.listFn();
        this.labelSetVisble = false;
      }
    },

    /* 编辑购票限制 */
    async ticketRestrictionsConfig(row) {
      this.ticketRestrictionsConfigRow = {
        id: row.id,
        ticketRestrictions: row.ticketRestrictions,
        customerRealName: row.customerRealName == 1 ? true : false,
        systemRealName: row.systemRealName == 1 ? true : false
      };
      this.ticketRestrictionsConfigVisible = true;
    },

    /* 下载二维码 */
    async downloadQrcode() {
      let oQrcode = document.getElementsByClassName("qr-code-down")[0];
      let a = document.createElement("a");
      a.href = oQrcode.src;

      a.download = "二维码";
      a.click();
    },

    // 查看规则
    async lookCommissionConfig(val) {
      this.line = val;
      let params = {
        commissionConfigId: val.commissionConfigId,
      };
      let url = "/api/v1/manage/line/commissionConfig/detail";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        data.data.commissionConfigRules = JSON.parse(
          data.data.commissionConfigRules
        );
        this.commissionConfigView = data.data;
      }
      this.outerVisible = true;
    },
    // 规则列表
    async getCommissionConfigList(row) {
      if (row) {
        this.line = row;
      }
      this.innerVisible = true;
      let params = {
        organizationId: this.line.organizationId,
      };
      let url = "/api/v1/manage/line/commissionConfig";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.commissionConfigList = data.data;
        if (this.line.commissionConfigId) {
          this.commissionConfigList.map((item, index) => {
            if (item.id == this.line.commissionConfigId) {
              this.radioCommissionConfig = index;
              this.checkCommissionConfig = item;
            }
          });
        } else {
          this.disableCommissionConfig = true;
        }
      }
    },
    // 选中行
    getCurrentRow(val) {
      this.checkCommissionConfig = val;
    },
    // 无规则状态
    changeCommissionConfig(val) {
      this.disableCommissionConfig = val;
      if (val) {
        this.radioCommissionConfig = null;
        this.checkCommissionConfig = null;
      }
    },
    // 保存更换规则
    async saveCommissionConfig() {
      if (this.checkCommissionConfig || this.disableCommissionConfig) {
        let params = {
          id: this.line.id,
          commissionConfigId: this.checkCommissionConfig
            ? this.checkCommissionConfig.id
            : null,
        };
        let url = "/api/v1/manage/line/commissionConfig/update";
        let data = await this.$axios.post(url, params);
        if (data && data.code === 1) {
          this.$message.success("已更换规则");
          this.$refs.customTable.listFn();
          this.innerVisible = false;
          this.outerVisible = false;
        }
      } else {
        this.$message.warning("请选择一条规则，或打开无提成规则");
        return;
      }
    },
    /* 状态改变 */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.schedulingType = this.schedulingType;
      this.$refs.customTable.listFn();
    },
    /* 列表-线路报班 */
    routeReporting(row) {
      this.$router.push({
        path: '/customizeReporting',
        query: {
          lineId: row.id,
          driverRegister: row.driverRegister
        }
      })

    },
    /* 列表-删除 */
    removeClick(row) {
      if (!this.btnPreFn("scheduling_remove")) {
        return;
      }
      if (row.schedulingDate) {
        this.$alert("已排班次的线路，无法被删除", "提示");
        return false;
      } else {
        this.$confirm(
          "确定要删除该线路吗？线路删除后，与该线路绑定的车辆自动解除绑定关系",
          "删除提示"
        ).then(async () => {
          let url = "/api/v1/manage/line";
          let params = {
            id: row.id,
          };
          let data = await this.$axios.delete(url, params);
          if (data && data.code === 1) {
            this.$message.success("删除成功");
            this.$refs.customTable.listFn();
          }
        });
      }
    },
    /* 编辑排班操作 */
    operationClick(row) {
      if (row.schedulingType) {
        if (row.schedulingDate) {
          this.$router.push({
            path: "/schedulingSetting",
            query: { lineId: row.id }
          });
        } else {
          this.$router.push({
            path: "/schedulingSettingEdit",
            query: { lineId: row.id }
          });
        }

      } else {
        this.$router.push({
          path: "/schedulingTypeForm",
          query: { lineId: row.id, lineName: row.startStationName + ' - ' + row.endStationName }
        });
      }
    },
    // 查看排班
    lookClick(row) {
      if (!this.btnPreFn("scheduling_scheduling")) {
        return;
      }
      this.$router.push({
        path: "/schedulingForm",
        query: {
          id: row.id,
          type: "scheduling",
          schedulingType: row.schedulingType,
        },
      });
    },

    /* 列表操作 */
    addClick() {
      if (this.btnPreFn("scheduling_add")) {
        this.$router.push("/dockingPoint");
      }
    },
  },
};
</script>

<style lang="less" scoped>
#customize {
  // 状态筛选
  .condition {
    /deep/ .el-radio-group {
      background: #f5f7fa;
      border-radius: 8px;
      padding: 4px;
      
      .el-radio-button {
        margin: 0 2px;
        
        .el-radio-button__inner {
          background: transparent;
          border: none;
          border-radius: 6px;
          padding: 8px 16px;
          font-size: 13px;
        }
        
        &.is-active .el-radio-button__inner {
          background: #2B77FF;
          color: #fff;
          box-shadow: none;
        }
      }
    }
  }

  // 操作按钮
  .el-dropdown-link {
    color: #2B77FF;
    cursor: pointer;
    font-size: 12px;
    
    &:hover {
      color: #1a5fd9;
    }
  }

  // 链接样式
  .link {
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }

  // 价格样式
  .util-money {
    font-weight: 600;
    color: #F56C6C;
  }

  // 提示样式
  .tips {
    color: #909399;
    font-size: 13px;
  }

  .priceForm {
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 0;
    }
  }

  .el-radio__label {
    display: none;
  }

  .flex {
    .el-radio {
      display: flex;
      align-items: center;
    }

    .el-radio__label {
      display: inline;
      font-weight: bold;
    }
  }

  // 弹窗样式
  :deep(.el-dialog) {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-dialog__footer {
      padding: 12px 20px;
      border-top: 1px solid #ebeef5;
      
      .el-button {
        border-radius: 6px;
      }
    }
  }

  // 表格样式
  :deep(.el-table) {
    border-radius: 8px;
    
    th {
      background: #f5f7fa !important;
      font-weight: 500;
    }
    
    .el-button--text {
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
  }
}

.box {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .item {
    width: 100%;
    margin: 12px 0;
    padding: 12px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-child {
      border-bottom: none;
    }

    .title {
      display: inline-block;
      width: 90px;
      margin-right: 16px;
      font-weight: 500;
      color: #606266;
    }

    .value {
      color: #303133;
    }
  }
}

.row-many {
  max-height: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.point {
  text-align: center;
  width: 100%;
  height: 100px;
  margin: 0 auto;
  padding: 20px;
  line-height: 25px;
  background: linear-gradient(135deg, #2B77FF 0%, #1a5fd9 100%);
  color: #fff;
  box-sizing: border-box;
  border-radius: 8px;

  .titleName {
    font-weight: 600;
    font-size: 17px;
    margin-bottom: 8px;
  }

  >p {
    font-size: 12px;
    opacity: 0.9;
  }
}

.point:nth-child(2) {
  background: linear-gradient(135deg, #35363b 0%, #1a1a1a 100%);
}

.handStyle {
  cursor: pointer;
}

.qr-code-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;

  .qr-code {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .text {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  .el-select {
    margin: 8px 0;
    width: 140px;

    .el-input {
      width: 100%;
    }
  }

  .util-remark {
    text-align: center;
    margin-top: 12px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
